// extracted by mini-css-extract-plugin
module.exports = {"box-shadow":"QuickRechner_box-shadow__93z8r"};